// src/data/pressureData.js
const pressureProducts = [
  {
    id: 1,
    name: "Pressure Transmitter",
    price: "₹5,000",
    image: "assets/sensors/PT.png",
    datasheet: "assets/pdf/sample.pdf",
  },
  {
    id: 2,
    name: "Digital Pressure Gauge",
    price: "₹3,500",
    image: "assets/sensors/PT.png",
    datasheet: "assets/pdf/sample.pdf",
  },
  {
    id: 3,
    name: "Pressure Switch",
    price: "₹2,800",
    image: "assets/sensors/PT.png",
    datasheet: "assets/pdf/sample.pdf",
  },
];

export default pressureProducts;
